export default "__VITE_ASSET__JqtBh0W$__"